import { PrimaryButton, SecondaryButton } from '@/components/buttons';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '@/components/ui/alert-dialog';
import { cn } from '@/lib/utils';
import { ReactNode } from 'react';

type Props = {
  trigger: ReactNode;
  title: string;
  description: string;
  actionLabel: string;
  cancelLabel?: string;
  onActionAccept: () => void;
};

const Alert = ({ trigger, description, title, onActionAccept, actionLabel, cancelLabel = 'Cancel' }: Props) => (
  <AlertDialog>
    <AlertDialogTrigger className={'w-full'}>{trigger}</AlertDialogTrigger>
    <AlertDialogContent className={cn('bg-white')}>
      <AlertDialogHeader>
        <AlertDialogTitle>{title}</AlertDialogTitle>
        <AlertDialogDescription>{description}</AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel asChild>
          <SecondaryButton size={'small'}>{cancelLabel}</SecondaryButton>
        </AlertDialogCancel>
        <AlertDialogAction asChild>
          <PrimaryButton size={'small'} onClick={onActionAccept}>
            {actionLabel}
          </PrimaryButton>
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);

export default Alert;
